jQuery(document).ready(function( $ ){

	// Bootstrap Popovers
	$(function () {
		$('[data-toggle="popover"]').popover();
	});

	// Hashes - scroll
	if(window.location.hash) {
		var hash = window.location.hash;

		// If message modal
		if(hash == '#message' && $('#message').length) {
			 $('#message').modal('show');
		}
		// end hash
	}


	// Double click menu
		//	$('.navbar li.dropdown .nav-link[aria-expanded="true"]').on('click', function(event) {
		//		event.preventDefault();
		//		window.location.href = this.href;
		// 	});




	// END JQUERY
});
